import { gql } from "@apollo/client";
import { REPORT_TEMPLATE_FRAGMENT } from "./getReportsTemplateCall";
import { Def_MutationResponse } from "../../UserCalls/GQLCalls/userCalls";
import { ReportTemplate } from "../../../../Definitions";

export const UPDATE_REPORT_TEMPLATE = gql`
  mutation UpdateTemplate($domain: String!, $templateId: Int!, $name: String!, $dataLevel: Int!, $filterParameter: [[FilterInput!]!]!, $shouldArchive: Boolean!) {
    report {
      updateTemplate(domain: $domain, report_template_id: $templateId, name: $name, data_level: $dataLevel, filter: $filterParameter, should_archive: $shouldArchive) {
        ...ReportTemplateFields
      }
    }
  }
  ${REPORT_TEMPLATE_FRAGMENT}
`


export interface MutateReportTemplateResponse extends Def_MutationResponse {
  updatedValues?: ReportTemplate[]
}

export interface UpdateReportTemplateResponse {
  report: {
    updateTemplate: MutateReportTemplateResponse 
  }
}